export default __webpack_public_path__ + "static/media/screen1.1765084e.png";